import { Button } from "semantic-ui-react";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import PublisherPriceForm from "./PublisherPriceForm";

export default function PublisherPricesActions(props) {
	const { t } = useTranslation();

	const [open, setOpen] = useState(false);

	return (
		<>
			<Button onClick={() => setOpen(true)}>{t("addDefaultPrice", "Add default price")}</Button>

			{open && <PublisherPriceForm {...props} onClose={() => setOpen(false)} />}
		</>
	);
}
